import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { DosageAnalyteConversion } from "./dosage/dosage-analyte-conversion";
import { DosageAvailableValues } from "./dosage/dosage-available-values";
import { DosageStandardTreatment } from "./dosage/dosage-standard-treatment";
import { FormulationAndRoute } from "../drug-models-list/formulation-and-route";

@staticImplements<ResponseModelInterfaceStatic>()
export class FormulationAndRouteFull extends FormulationAndRoute
{
    public constructor(
        baseFormulationAndRoute: FormulationAndRoute,
        public id: string,
        public dosageStandardTreatment: DosageStandardTreatment|null,
        public dosageAnalyteConversions: DosageAnalyteConversion[],
        public dosageAvailableDoses: DosageAvailableValues,
        public dosageAvailableIntervals: DosageAvailableValues,
        public dosageAvailableInfusions: DosageAvailableValues|null,
    )
    {
        super(
            baseFormulationAndRoute.formulation,
            baseFormulationAndRoute.administrationName,
            baseFormulationAndRoute.administrationRoute,
            baseFormulationAndRoute.absorptionModel
        );
    }

    public static makeFromXml(elem: XmlElementWrapper): FormulationAndRouteFull
    {
        const dosagesElem = elem.firstChildByTag("dosages");
        const stdTreatmentElem = dosagesElem.firstChildByTagOrNull("standardTreatment");
        const conversionsElem = dosagesElem.firstChildByTag("analyteConversions");
        const dosesElem = dosagesElem.firstChildByTag("availableDoses");
        const intervalsElem = dosagesElem.firstChildByTag("availableIntervals");
        const infusionsElem = dosagesElem.firstChildByTagOrNull("availableInfusions");

        return new this(
            FormulationAndRoute.makeFromXml(elem),
            elem.firstChildByTag("formulationAndRouteId").value(),
            (stdTreatmentElem === null) ? null : DosageStandardTreatment.makeFromXml(stdTreatmentElem),
            conversionsElem.mapForEachChildTag("analyteConversion", (subElem) => DosageAnalyteConversion.makeFromXml(subElem)),
            DosageAvailableValues.makeFromXml(dosesElem),
            DosageAvailableValues.makeFromXml(intervalsElem),
            (infusionsElem === null) ? null : DosageAvailableValues.makeFromXml(infusionsElem),
        );
    }
}
